import {
  ExtractFnReturnType,
  InfiniteQueryConfigType,
  useInfiniteQuery,
  UseInfiniteQueryResult,
} from "~/libs";

import { ApiClient } from "~/utils";

import {
  ApiMembersBookmarkedInsightPostsIndexResponseType,
  ApiMembersBookmarkedInsightPostsIndexRequestType,
} from "~/domains";

type RequestDataType = {
  params?: ApiMembersBookmarkedInsightPostsIndexRequestType;
  page?: number;
};

const request = async ({
  params,
  page = 1,
}: RequestDataType): Promise<ApiMembersBookmarkedInsightPostsIndexResponseType> => {
  const response =
    await new ApiClient().get<ApiMembersBookmarkedInsightPostsIndexResponseType>(
      "/api/members/bookmarked_insight_posts",
      { page, ...params },
    );
  return response.data;
};

type QueryFnType = typeof request;

type PropsType = {
  params?: ApiMembersBookmarkedInsightPostsIndexRequestType;
  config?: InfiniteQueryConfigType<QueryFnType>;
};

export const useApisMembersBookmarkedInsightPostsIndex = ({
  params,
  config = {},
}: PropsType = {}): UseInfiniteQueryResult<ApiMembersBookmarkedInsightPostsIndexResponseType> => {
  return useInfiniteQuery<ExtractFnReturnType<QueryFnType>>(
    ["ApisMembersBookmarkedInsightPostsIndex", params],
    ({ pageParam }) => {
      return request({ params, page: pageParam as number | undefined });
    },
    {
      ...config,
      getNextPageParam: (data) => {
        return data.pagy.hasMore ? data.pagy.currentPage + 1 : false;
      },
    },
  );
};
